/* eslint-disable @typescript-eslint/no-unused-vars */
import ClientResponseProps from 'common/types/UserResponseProps';
import React, { useEffect, useRef, useState } from 'react';
import { FullItem, Separator } from '../OrderProductSettings';
import { CategoryButton, ContentContainer, OrderInfoSeparator, SidebarCategoryScroller, SidebarCategoryWrapper, SidebarInfoWrapper, SidebarWrapper, StyledListCard } from 'pages/CreateOrderPage/styles/CreateOrderStyles';
import useSearch from 'common/hooks/useSearch';
import CategoryProps from 'pages/CreateOrderPage/types/CategoryProps';
import Button from 'common/components/Button';
import styled from '@emotion/styled';
import { ReactComponent as ClientIcon } from '../../icons/order-completion-client-icon.svg';
import { ReactComponent as EditIcon } from 'common/icons/pencil-line.svg';
import Checkbox from 'common/components/Checkbox';
import { Radio, Switch, useTheme } from '@mui/material';
import SearchInput from 'common/components/SearchInput';
import { ListContainer } from 'pages/CreateOrderPage/components/ListContainer';
import { useCalculateCardNumber } from 'pages/CreateOrderPage/hooks/useCalculateCardNumber';
import useScreenSize from 'common/hooks/useScreenSize';
import { CompletionDataProps } from 'pages/CreateOrderPage/types/CompletionDataProps';
import { useFetchServiceParams } from 'pages/CreateOrderPage/hooks/useFetchServiceParams';
import { useFetchLocationParams } from 'pages/CreateOrderPage/hooks/useFetchLocationParams';
import Pagination from 'common/components/Pagination';
import Input from 'common/components/Input';
import TextArea from 'common/components/TextArea';
import { Tag } from 'pages/CreateOrderPage/styles/TagStyles';
import { ReactComponent as CrossIcon } from 'common/icons/plus.svg';
import { ReactComponent as BonusIcon } from '../../icons/bonus.svg';
// uuidv4 for id
import { v4 as uuidv4 } from 'uuid';
import { useNavigate } from 'react-router-dom';
//<OrderCompletionPage orderId={orderId} setStage={setStage} client={client} firm={firm} priceList={priceList} itemList={itemList} setPageType={setPageType} />
// Контактні дані, Видача, Отримувач, Бонуси, Промокоди, Оплата, Інше
const categoryList: CategoryProps[] = [
  {
    id: 1,
    name: 'Контактні дані',
  },
  {
    id: 2,
    name: 'Пункт видачі',
  },
  {
    id: 3,
    name: 'Отримувач',
  },
  {
    id: 4,
    name: 'Бонуси',
  },
  {
    id: 5,
    name: 'Промокоди',
  },
  {
    id: 6,
    name: 'Оплата',
  },
  {
    id: 7,
    name: 'Інше',
  },
];


const ListCard = ({ id, name, cardWidth, selectedItem, varName, onClick }: { id: string | number; name: string; cardWidth: number; varName: string, selectedItem: CompletionDataProps, onClick: (varName: string, id: string | number) => void; }) => {
  // check if item is selected in selectedItem[varName] that is an array of ids
  let selected;
  if (varName !== 'clothesGender' && varName !== 'marking') selected = selectedItem[varName] && selectedItem[varName].includes(id);
  else selected = selectedItem[varName] === id;
  return (
        <StyledListCard onClick={() => { onClick(varName, id); }} cardWidth={cardWidth} className={selected ? 'active' : ''}>
            <Checkbox onChange={() => { onClick(varName, id); }} checked={selected} />
            <p>{name}</p>
        </StyledListCard>
  );
};

const ListRadioCard = ({ id, name, cardWidth, selectedItem, varName, onClick }: { id: string | number; name: string; cardWidth: number; varName: string, selectedItem: CompletionDataProps, onClick: (varName: string, id: string | number) => void; }) => {
  // check if item is selected in selectedItem[varName] that is an array of ids
  const selected = selectedItem[varName] === id;
  return (
        <StyledListCard onClick={() => { onClick(varName, id); }} cardWidth={cardWidth} className={selected ? 'active' : ''}>
            <Radio onChange={() => { onClick(varName, id); }} checked={selected} />
            <p>{name}</p>
        </StyledListCard>
  );
};

const ListClientCard = ({ selected, onClick, name }: { selected: boolean, onClick: () => void; name: string }) => {
  // check if item is selected in selectedItem[varName] that is an array of ids
  return (
        <StyledListCard onClick={() => { onClick(); }} cardWidth={300} className={selected ? 'active' : ''}>
            <Radio onChange={() => { onClick(); }} checked={selected} />
            <p>{name}</p>
        </StyledListCard>
  );
};



const ClientCardContainer = styled.div`
    border-radius: 8px;
    height: 76px;
    width: 100%;
    border: 1px solid ${(props) => props.theme.colors.gray};
    display:flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 16px;
    margin-bottom: 24px;
`;



export const ClientCard = ({ client, setPageType }: { client: ClientResponseProps, setPageType: React.Dispatch<React.SetStateAction<string>> }) => {
  return (
        <ClientCardContainer>
            <div className='order-completion-client-side'>
                <div className='order-completion-client-image-wrapper'>
                    <ClientIcon className='svg-black' />
                </div>
                <div className='order-completion-client-text-warpper'>
                    <p className='order-infor-price-title'>{client?.companyNumber ? client?.companyName : `${client?.lastName.charAt(0).toUpperCase() + client?.lastName.slice(1)} ${client?.firstName.charAt(0).toUpperCase() + client?.firstName.slice(1)} ${client?.patronymic ? client?.patronymic.charAt(0).toUpperCase() + client?.patronymic.slice(1) : ''}`}</p>
                    <span style={{ lineHeight: 16 + 'px' }} className='order-product-list-card-title'>{`${client?.country}${client?.city ? ', ' + client?.city : ''}`} {client?.country ? '|' : ''} {client?.phoneNumber}</span>
                </div>
            </div>
            <button onClick={()=>{setPageType('edit-client');}} className='order-completion-edit-button-wrapper'>
                <EditIcon className='svg-black' />
            </button>
        </ClientCardContainer>
  );
};

type OrderCompletionPageProps = {
  orderId: string | number;
  setStage: React.Dispatch<React.SetStateAction<number>>;
  client: ClientResponseProps;
  firm: string | number;
  priceList: string | number;
  itemList: FullItem[];
  setPageType: React.Dispatch<React.SetStateAction<string>>;
  completionData: CompletionDataProps;
  setCompletionData: React.Dispatch<React.SetStateAction<CompletionDataProps>>;
  finishOrder: () => void;
};


export default function OrderCompletionPage({ setPageType, client, orderId, itemList, completionData, setCompletionData, finishOrder }: OrderCompletionPageProps) {
  const [category, setCategory] = useState(1 as number);
  const theme = useTheme();
  const { searchValue, onSearchChange, clearSearch } = useSearch();
  const [page, setPage] = useState(1 as number);
  const listRef = useRef(null);
  const [dateValue, setDateValue] = useState('' as string);
  const [timeValue, setTimeValue] = useState('' as string);
  const [promocodeValue, setPromocodeValue] = useState('' as string);
  
  useEffect(() => {
    if (client) {
      setCompletionData({ ...completionData, client: {
        lastName: client.lastName,
        firstName: client.firstName,
        patronymic: client.patronymic,
        phoneNumber: client.phoneNumber,
      } });
    }
  }, []);

  const changeCategory = (e: React.MouseEvent<HTMLButtonElement>) => {
    const target = e.target as HTMLButtonElement;
    clearSearch();

    setPage(1);
    setCategory(Number(target.dataset.id));
  };
    // summ itemList[i].count in each item with type === 'product' and type === 'service'
  const serviceItemCount = itemList.filter((el) => el.type === 'service').reduce((acc, el) => acc + el.count, 0);
  const productItemCount = itemList.filter((el) => el.type === 'product').reduce((acc, el) => acc + el.count, 0);
  const itemSumm = itemList.reduce((acc, el) => acc + el.count * el.price, 0);
  const handleCardClick = (varName: string, id: string | number) => {
    // add id into array if not exist, remove if exist
    if (varName !== 'clothesGender' && varName !== 'marking') {
      if (completionData[varName] && completionData[varName].includes(id)) {
        setCompletionData({ ...completionData, [varName]: completionData[varName].filter((el) => el !== id) });
      } else {
        setCompletionData({ ...completionData, [varName]: [...completionData[varName], id] });
      }
    } else {
      setCompletionData({ ...completionData, [varName]: id });
    }
  };

  const handleSingleCardClick = (varName: string, id: string | number) => {
    setCompletionData({ ...completionData, [varName]: id });
  };

  const addPromocode = () => {
    // uuidv4 for id
    const randomId = uuidv4();
    setCompletionData({ ...completionData, promocode: [...completionData.promocode, { id: randomId, name: promocodeValue }] });
    setPromocodeValue('');
  };
  const removePromocode = (id: string | number) => {
    setCompletionData({ ...completionData, promocode: completionData.promocode.filter((el) => el.id !== id) });
  };


  useEffect(() => {
    // update issueDate Date in completionData when dateValue or timeValue changes, if no time set current time, if no date set current date

    console.log(dateValue, timeValue);
    if (dateValue && timeValue) {
      const date = new Date(dateValue);
      const timeVals = timeValue.split(':');
      const time = new Date(date.getFullYear(), date.getMonth(), date.getDate(), Number(timeVals[0]), Number(timeVals[1]), 0);

      const issueDate = new Date(date.getFullYear(), date.getMonth(), date.getDate(), time.getHours(), time.getMinutes(), time.getSeconds());
      setCompletionData({ ...completionData, issueDate });
    } else if (dateValue) {
      const date = new Date(dateValue);
      const issueDate = new Date(date.getFullYear(), date.getMonth(), date.getDate(), new Date().getHours(), new Date().getMinutes(), new Date().getSeconds());
      setCompletionData({ ...completionData, issueDate });
    } else if (timeValue) {
      const date = new Date();
      const timeVals = timeValue.split(':');
      const time = new Date(date.getFullYear(), date.getMonth(), date.getDate(), Number(timeVals[0]), Number(timeVals[1]), 0);
      const issueDate = new Date(date.getFullYear(), date.getMonth(), date.getDate(), time.getHours(), time.getMinutes(), time.getSeconds());
      // convert to string in this format: '2021-10-20T10:10:10.000Z'
      setCompletionData({ ...completionData, issueDate });
    }

  }, [dateValue, timeValue]);
  const { width, height } = useScreenSize();
  const { searchedList } = useFetchLocationParams(searchValue, completionData);
  const { shownList, pageCount } = useCalculateCardNumber(category, searchedList, listRef, 300, page, setPage, height, width, 80);
  return (
        <div className='order-content-container'>
            <div className='order-content-wrapper'>
                <div className='order-content-half'>
                    <SidebarWrapper>
                        <SidebarCategoryWrapper style={{ flexBasis:'35%' }}>
                            <SidebarCategoryScroller>
                                <h3 className='new-h3 order-category-title'>Параметри</h3>
                                {categoryList.map((el) => (
                                    <CategoryButton onClick={changeCategory} className={category === el.id ? 'active' : ''} data-id={el.id} key={el.id}>
                                        {el.name}
                                    </CategoryButton>
                                ))}
                            </SidebarCategoryScroller>
                        </SidebarCategoryWrapper>
                        <SidebarInfoWrapper style={{ flexBasis:'65%' }}>
                            <h3 className='new-h3 order-category-title find-client-info-title'>Інформація про замовлення</h3>
                            <div className='find-client-info-list u-fancy-scrollbar'>
                                <div className='find-client-info-line'>
                                    <p className='find-client-info-line-title'>№ замовлення</p>
                                    <p className='find-client-info-line-value'>{orderId}</p>
                                </div>
                                <div className='find-client-info-line'>
                                    <p className='find-client-info-line-title'>К-ть товарів</p>
                                    <p className='find-client-info-line-value'>{serviceItemCount}</p>
                                </div>
                                <div className='find-client-info-line'>
                                    <p className='find-client-info-line-title'>К-ть послуг</p>
                                    <p className='find-client-info-line-value'>{productItemCount}</p>
                                </div>
                                <div className='find-client-info-line'>
                                    <p className='find-client-info-line-title'>Сумма</p>
                                    <p className='find-client-info-line-value'>
                                        {itemSumm.toFixed(2) || '0.00'} ₴
                                    </p>
                                </div>
                                <div className='find-client-info-line'>
                                    <p className='find-client-info-line-title'>Бонуси</p>
                                    <p className='find-client-info-line-value'>—</p>
                                </div>
                                <div className='find-client-info-line'>
                                    <p className='find-client-info-line-title'>Промокоди</p>
                                    <p className='find-client-info-line-value'>—</p>
                                </div>

                            </div>
                            <div className='order-info-price-wrapper'>
                                <OrderInfoSeparator />
                                <div className='order-info-price-line'>
                                    <span className='order-infor-price-title'>До сплати</span>
                                    <span className='order-infor-price-title'>{itemSumm.toFixed(2) || '0.00'} ₴</span>
                                </div>
                            </div>
                        </SidebarInfoWrapper>
                    </SidebarWrapper>
                    <ContentContainer>
                        {category === 1 && <>
                            <div className='find-client-top-line'>
                                <span className='big-text'>
                                    Контактні дані
                                </span>
                                <span className='order-subtext gray-text'>

                                </span>
                            </div>
                            <div className='order-padding'>
                                <ClientCard setPageType={setPageType} client={client} />
                                <p style={{ marginBottom: 24 + 'px' }} className='order-infor-price-title'>
                                    Клієнт згоден:
                                </p>
                                <div className='order-completion-client-card-list'>
                                    <ListCard
                                        cardWidth={200}
                                        id={1}
                                        name='Отримувати повідомлення про готовність замовлення'
                                        selectedItem={completionData}
                                        varName={'agreements'}
                                        onClick={handleCardClick}
                                    />
                                    <ListCard
                                        cardWidth={200}
                                        id={2}
                                        name='Отримувати квітанцію в ел. виді'
                                        selectedItem={completionData}
                                        varName={'agreements'}
                                        onClick={handleCardClick}
                                    />
                                    <ListCard
                                        cardWidth={200}
                                        id={3}
                                        name='Отримувати повідомлення про зміни в замовлені'
                                        selectedItem={completionData}
                                        varName={'agreements'}
                                        onClick={handleCardClick}
                                    />
                                </div>
                                <div className='order-completion-client-switch-line'>
                                    <p className='new-p'>Замовлення для партнера</p>
                                    <Switch
                                        sx={{
                                          '& .MuiSwitch-thumb': {
                                            backgroundColor: theme.colors.gray,
                                            filter: 'drop-shadow(0px 2px 1px rgba(0, 0, 0, 0.20)) drop-shadow(0px 1px 1px rgba(0, 0, 0, 0.14)) drop-shadow(0px 1px 3px rgba(0, 0, 0, 0.12))',
                                          },
                                          '& .MuiSwitch-track': {
                                            backgroundColor: theme.colors.gray,
                                          },
                                          '& .Mui-checked .MuiSwitch-thumb': {
                                            backgroundColor: theme.colors.primaryColor,
                                          },
                                        }}
                                        checked={completionData.isPartner}
                                        onChange={() => { setCompletionData({ ...completionData, isPartner: !completionData.isPartner }); }}
                                    />
                                </div>
                            </div>
                        </>
                        }
                        {category === 2 && <>
                            <div className='find-client-top-line'>
                                <span className='big-text'>
                                    Пункт видачі
                                </span>
                                <span className='order-subtext gray-text'>

                                </span>
                            </div>
                            <div className='order-completion-search-line'>
                                <SearchInput wrapperStyle={{ flex: '1 0 auto' }} style={{ width: '100%' }} value={searchValue} onChange={onSearchChange} placeholder='Пошук...' />
                            </div>
                            <ListContainer listRef={listRef} cardWidth={300}>
                                {shownList.length > 0 && shownList.map((item) => (
                                    <ListRadioCard
                                        key={item.id}
                                        id={item.id}
                                        name={item.name}
                                        cardWidth={300}
                                        selectedItem={completionData}
                                        varName={'locationId'}
                                        onClick={handleSingleCardClick}
                                    />
                                ))}
                            </ListContainer>
                            <div className='order-pagination-wrapper'>
                                {pageCount >= 2 && <Pagination count={pageCount} page={page} setPage={setPage} />}
                            </div>
                            <div className='order-completion-time-wrapper'>
                                <Separator />
                                <div className='order-completion-time-line'>
                                    <p className='new-p'>Дата</p>
                                    <Input props={{ type: 'date' }} placeholder='Введіть дату видачі' value={dateValue} onChange={(e) => { setDateValue(e.target.value); }} />
                                    <p className='new-p'>Час</p>
                                    <Input props={{ type: 'time' }} placeholder='Введіть час видачі' value={timeValue} onChange={(e) => { setTimeValue(e.target.value); }} />
                                </div>
                            </div>
                        </>}
                        {category === 3 && <>
                            <div className='find-client-top-line'>
                                <span className='big-text'>
                                    Отримувач
                                </span>
                                <span className='order-subtext gray-text'>

                                </span>
                            </div>
                            <div className='order-padding'>
                                <p style={{ marginBottom: 24 + 'px' }} className='order-infor-price-title'>Оберіть отримувача замовлення</p>
                                <div className='order-completion-client-card-list'>
                                    <ListClientCard
                                        name={client.companyNumber ? client.companyName : `${client.lastName} ${client.firstName} ${client.patronymic ? client.patronymic : ''}`}
                                        selected={!completionData.isOther}
                                        onClick={() => {
                                          setCompletionData({
                                            ...completionData, client: {
                                              lastName: client.lastName,
                                              firstName: client.firstName,
                                              patronymic: client.patronymic,
                                              phoneNumber: client.phoneNumber,
                                            },
                                            isOther: false,

                                          });
                                        }}
                                    />
                                    <ListClientCard
                                        name='Інший отримувач'
                                        selected={completionData.isOther}
                                        onClick={() => {
                                          setCompletionData({
                                            ...completionData, client: {
                                              lastName: '',
                                              firstName: '',
                                              patronymic: '',
                                              phoneNumber: '',
                                            },
                                            isOther: true,
                                          });
                                        }}
                                    />
                                </div>
                                {completionData.isOther && <>
                                    <div className='order-completion-custom-client-wrapper'>
                                        <div className='order-completion-custom-client-line'>
                                            <p className='new-p'>Прізвище</p>
                                            <Input placeholder='Введіть прізвище отримувача' value={completionData.client.lastName} onChange={(e) => { setCompletionData({ ...completionData, client: { ...completionData.client, lastName: e.target.value } }); }} />
                                        </div>
                                        <div className='order-completion-custom-client-line'>
                                            <p className='new-p'>{"Ім'я"}</p>
                                            <Input placeholder='Введіть ім’я отримувача' value={completionData.client.firstName} onChange={(e) => { setCompletionData({ ...completionData, client: { ...completionData.client, firstName: e.target.value } }); }} />
                                        </div>
                                        <div className='order-completion-custom-client-line'>
                                            <p className='new-p'>По батькові</p>
                                            <Input placeholder='Введіть по батькові отримувача' value={completionData.client.patronymic} onChange={(e) => { setCompletionData({ ...completionData, client: { ...completionData.client, patronymic: e.target.value } }); }} />
                                        </div>
                                        <div className='order-completion-custom-client-line'>
                                            <p className='new-p'>Номер телефону</p>
                                            <Input placeholder='Введіть номер телефону отримувача' value={completionData.client.phoneNumber} onChange={(e) => { setCompletionData({ ...completionData, client: { ...completionData.client, phoneNumber: e.target.value } }); }} />
                                        </div>
                                    </div>
                                </>}
                            </div>
                        </>}
                        {category === 4 && <>
                            <div className='find-client-top-line'>
                                <span className='big-text'>
                                    Бонуси
                                </span>
                                <span className='order-subtext gray-text'>

                                </span>
                            </div>
                            <div className='order-padding'>
                                <ClientCardContainer>
                                    <div className='order-completion-client-side'>
                                        <div className='order-completion-client-image-wrapper'>
                                            <BonusIcon className='svg-black' />
                                        </div>
                                        <div className='order-completion-client-text-warpper'>
                                            <p className='order-infor-price-title'>140</p>
                                            <span style={{ lineHeight: 16 + 'px' }} className='order-product-list-card-title'>Загальна кількість бонусів</span>
                                        </div>
                                    </div>
                                    <div></div>
                                </ClientCardContainer>
                                <div className='order-completion-client-switch-line'>
                                    <p className='new-p'>Використати бонуси</p>
                                    <Switch
                                        sx={{
                                          '& .MuiSwitch-thumb': {
                                            backgroundColor: theme.colors.gray,
                                            filter: 'drop-shadow(0px 2px 1px rgba(0, 0, 0, 0.20)) drop-shadow(0px 1px 1px rgba(0, 0, 0, 0.14)) drop-shadow(0px 1px 3px rgba(0, 0, 0, 0.12))',
                                          },
                                          '& .MuiSwitch-track': {
                                            backgroundColor: theme.colors.gray,
                                          },
                                          '& .Mui-checked .MuiSwitch-thumb': {
                                            backgroundColor: theme.colors.primaryColor,
                                          },
                                        }}
                                        checked={completionData.useBonuses}
                                        onChange={() => { setCompletionData({ ...completionData, useBonuses: !completionData.useBonuses }); }}
                                    />
                                </div>
                            </div>
                        </>}
                        {category === 5 && <>
                            <div className='find-client-top-line'>
                                <span className='big-text'>
                                    Промокоди
                                </span>
                                <span className='order-subtext gray-text'>

                                </span>
                            </div>
                            <div className='order-padding'>
                                <p style={{ marginBottom: 24 + 'px' }} className='order-infor-price-title'>
                                    Тип промокоду
                                </p>
                                <div className='order-completion-client-card-list'>
                                    <ListClientCard
                                        name='Загальний'
                                        selected={completionData.promocodeType === 1}
                                        onClick={() => { setCompletionData({ ...completionData, promocodeType: 1 }); }}
                                    />
                                    <ListClientCard
                                        name='Персональний'
                                        selected={completionData.promocodeType === 2}
                                        onClick={() => { setCompletionData({ ...completionData, promocodeType: 2 }); }}
                                    />
                                    <ListClientCard
                                        name='Партнерський'
                                        selected={completionData.promocodeType === 3}
                                        onClick={() => { setCompletionData({ ...completionData, promocodeType: 3 }); }}
                                    />
                                </div>
                                <div style={{ marginBottom: '12px' }} className='order-completion-custom-client-line'>
                                    <p className='new-p'>Код</p>
                                    <div className='order-completion-promocode-input-wrapper'>
                                        <Input placeholder='Введіть промокод' value={promocodeValue} onChange={(e) => { setPromocodeValue(e.target.value); }} props={{ onKeyPress: (e) => { if (e.key === 'Enter') addPromocode(); } }} />
                                        <CrossIcon className='svg-black' height={20} width={20} onClick={addPromocode} />
                                    </div>
                                </div>
                                <div className='order-completion-promocode-list'>
                                    {completionData.promocode.map((el, index) => (
                                        <Tag key={index}>
                                            {el.name}
                                            <div onClick={() => { removePromocode(el.id); }} className='order-tag-searchbar-cross'>
                                                <CrossIcon className='svg-black' />
                                            </div>
                                        </Tag>
                                    ))}
                                </div>
                            </div>
                        </>}
                        {category === 6 && <>
                            <div className='find-client-top-line'>
                                <span className='big-text'>
                                    Оплата
                                </span>
                                <span className='order-subtext gray-text'>

                                </span>
                            </div>
                            <div className='order-padding'>
                                <div className='order-completion-client-card-list'>
                                    <ListClientCard
                                        name='Карта'
                                        selected={completionData.paymentType === 1}
                                        onClick={() => { setCompletionData({ ...completionData, paymentType: 1 }); }}
                                    />
                                    <ListClientCard
                                        name='Готівка'
                                        selected={completionData.paymentType === 2}
                                        onClick={() => { setCompletionData({ ...completionData, paymentType: 2 }); }}
                                    />
                                    <ListClientCard
                                        name='Розрахунковий рахунок'
                                        selected={completionData.paymentType === 3}
                                        onClick={() => { setCompletionData({ ...completionData, paymentType: 3 }); }}
                                    />
                                </div>
                            </div>
                        </>}
                        {category === 7 && <>
                            <div className='find-client-top-line'>
                                <span className='big-text'>
                                    Інше
                                </span>
                                <span className='order-subtext gray-text'>

                                </span>
                            </div>
                            <div className='order-padding'>
                                <div className='order-completion-custom-client-line'>
                                    <p className='new-p'>Комментар</p>
                                    <TextArea placeholder='Опишіть важливу інформацію' height={'84px'} value={completionData.comment} onChange={(e) => { setCompletionData({ ...completionData, comment: e.target.value }); }} />
                                </div>
                            </div>
                        </>}
                    </ContentContainer>
                </div>
                <div style={{ marginTop: 0 }} className='order-product-button-wrapper'>
                    <Button label='У чернетку' disabled />
                    <Button onClick={()=>{setPageType('info');}} primary label='Підтвердити' />
                </div>
            </div>
        </div>

  );
}